<div class="dialog-container small-dialog">
  <h3 class="dialog-header">
    <div class="flex">
      امتیازات
    </div>
    <button (click)="dialogRef.close()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </h3>
  <div class="dialog-content">
    <div class="row-center">
      <div matRipple class="btn" (click)="scoreSelecter=item" *ngFor="let item of [1,2,3,4,5];index as i">
        <i class="material-icons">
          {{item <=scoreSelecter ? 'star':'star_border'}}
        </i>
      </div>
    </div>

  </div>
  <div class="dialog-action">
    <button mat-button (click)="dialogRef.close()">بستن</button>
    <button mat-raised-button (click)="saveChanges()" color="primary">ثبت</button> </div>
</div>
